import Api from "..";
import TransmedEdition, {
  TransmedEditionInput,
} from "../../dtos/transmed/process/edition";
import transform from "../../service/transform";

export default class TransmedEditionApi extends Api {
  constructor() {
    super("transmed/edition");
  }

  public async get(): Promise<TransmedEdition> {
    return await transform(TransmedEdition)((await super.get("last")).data);
  }

  public async put(
    id: 'last',
    data: TransmedEditionInput
  ): Promise<TransmedEdition> {
    return await transform(TransmedEdition)((await super.put(id, data)).data);
  }

  public async post(): Promise<TransmedEdition> {
    return await transform(TransmedEdition)((await super.post()).data);
  }
}
